<app-card cardTitle="{{'changePaySlip' | translate}}" [padding]="20">
    <ng-template #headerOptionsTemplate>
        <a href="javascript:" class="text-muted" mat-dialog-close>
            <i class="ti ti-x f-20"></i>
        </a>
    </ng-template>
    <div style="height: 150px;justify-content: space-between;
    display: flex;">
        <mat-form-field appearance="outline" style="height: 50px;">
            <mat-label>{{'paySlip' | translate}}</mat-label>
            <mat-select [(ngModel)]="selectedPaySlip" name="exOption" (selectionChange)="paySlipSelect($event.value)">
                @for (paySlip of paySlipsData; track paySlip) {
                <mat-option [value]="paySlip.payslip.payslipcode">
                    {{currentLang == 'ar' ? paySlip.payslip.paysliparaname : paySlip.payslip.paysliplatname}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <button mat-flat-button color="primary" class="m-r-10" mat-dialog-close>{{'ok' |
            translate}}</button>
    </div>
</app-card>